import React, { useEffect, useState } from "react";
import {
    createClickableLink
} from "../../../../components/common/datatable/DataTableUtils";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useLazyExportAccountTransDataQuery, useSearchAccountTransQuery } from "../accountTransApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa";
import {
    SearchSelectWithEnum,
} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import CollectorSearchInputWrapper from "../../../../components/common/datatable/filter/CollectorSearchInputWrapper";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";

const Translation = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Account Translation");
    const { data: enums } = useGetEnumsQuery("");
    const [exportTranslatonAction,exportTranslations]= useLazyExportAccountTransDataQuery();
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Account Translations", url: "" }]
    )
    const navigate = useNavigate()
    useEffect(() => {
        document.title = 'Account Translations';
    }, []);

    const columns: DataTableColumn[] = [
        {
            label: hasPermission(["ACCTRA-R"]) ? <span>Action</span> : <span />,
            accessor: "id",
            canSort: false,
            cell: (props: any) => {
                if (hasPermission(["ACCTRA-R"])) {
                    const path = "/account-translations/" + props.row.original.id;
                    return createClickableLink(path, "", userSetting, true, "fa fa-edit cursor-pointer text-highlight-0");
                } else {
                    return <></>;
                }
            }
        },
        {
            label: "Source Collector",
            accessor: "sourceCollector.name",
            canSort: false,
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "sourceCollectorId",
                overrideFilterLabel: "Source Collector",
            }]
        },
        {
            label: "Destination Collector",
            accessor: "destinationCollector.name",
            canSort: false,
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "destinationCollectorId",
                overrideFilterLabel: "Destination Collector",
            }]
        },
        {
            label: "Source Target",
            accessor: "sourceTarget",
            cell: (props: any) => {
                return <>
                    <span>{enums?.["AccountTranslationTarget"] && enums?.["AccountTranslationTarget"].map((curEnum: any) => {
                        if (curEnum.constant === props.value) return curEnum.value
                    })}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["AccountTranslationTarget"], "Select Translation Target......", false, "sourceTarget"),
                overrideFilterAccessor: "sourceTarget",
            }],
        },
        {
            label: "Destination Target",
            accessor: "destinationTarget",
            cell: (props: any) => {
                return <>
                    <span>{enums?.["AccountTranslationTarget"] && enums?.["AccountTranslationTarget"].map((curEnum: any) => {
                        if (curEnum.constant === props.value) return curEnum.value
                    })}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["AccountTranslationTarget"], "Select Translation Target......", false, "destinationTarget"),
                overrideFilterAccessor: "destinationTarget",
            }],
        },
        {
            label: "Number Type", accessor: "accountNumberType",
            cell: (props: any) => {
                return <>
                    <span>{enums?.["AccountNumberType"] && enums?.["AccountNumberType"].map((curEnum: any) => {
                        if (curEnum.constant === props.value) return curEnum.value
                    })}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["AccountNumberType"], "Select Number Type......", false, "accountNumberType"),
                overrideFilterAccessor: "accountNumberType",
            }],
        },
    ]

    return (
        <div className="user-container px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <div className="table_data mt-2">
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchAccountTransQuery,
                        exportAction:exportTranslatonAction
                    }}
                    userSettingGroup={"Account Translation"}
                    defaultSortOptions={{
                        accessor: "accountNumberType",
                        direction: "asc"
                    }}

                    defaultFilter={{
                        pageNumber: 0,
                        pageSize: 25
                    }}
                   
                    buttonOptions={{
                        addButton:
                        {
                            button: <IconButton
                                icon={<FaPlus />}
                                hasBackground={true}
                                onClick={() => {
                                    navigate("/account-translations/create")
                                }}
                                title={"Create Account Translations"}
                            />,
                            permissions: ["ACCTRA-C"]
                        },
                    }}
                    basePermission={"ACCTRA"}
                />
            </div>
        </div>
    );
};
export default Translation;
